import { render, staticRenderFns } from "./BAddWorkDay.vue?vue&type=template&id=5035a605"
import script from "./BAddWorkDay.vue?vue&type=script&lang=js"
export * from "./BAddWorkDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports